import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { DgMktMessageTemplateContainerModel } from '../../../../../../models/aggregates/dgmkt/dgmkt-message-template/dgmkt-message-template-container.model';

@Injectable({
  providedIn: 'root',
})
export class DgMktMessageTemplateService extends BaseApiTemplateService<DgMktMessageTemplateContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'message-templates';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'message-templates';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'message-templates';
    this.httpClient = http;
  }
}
